import {useState} from 'react';
import NameUploader from './components/NameUploader';
import WheelCanvas from './components/WheelCanvas';
import SpinController from './components/SpinController';
import WinnerPopup from './components/WinnerPopup';
import './styles/App.css';

function App() {
  const [names, setNames] = useState<string[]>([]);
  const [spinning, setSpinning] = useState(false);
  const [winner, setWinner] = useState('');
  const [popup, setPopup] = useState(false);
  const icon = '/your-icon.png'; // Place your icon in /public

  return (
    <div className="app-container">
      <header className="app-header">
        <h1>Spinning Wheel</h1>
        <p className="app-subtitle">Add names and press space to spin</p>
      </header>

      <div className="app-content">
        <div className="sidebar">
          <div className="panel">
            <h2>Contestants</h2>
            <NameUploader onNamesLoaded={setNames} />
          </div>
          <div className="panel">
            <h2>Controls</h2>
            <div className="controls-info">
              <p><span className="keyboard-key">Space</span> - Hold to spin</p>
              <p><span className="keyboard-key">Esc</span> - Stop spinning</p>
            </div>
            <SpinController onSpinChange={(state) => setSpinning(state)} />
          </div>
        </div>

        <div className="wheel-container">
          <WheelCanvas
            names={names}
            isSpinning={spinning}
            onStop={(w) => {
              setWinner(w);
              setPopup(true);
            }}
            centerIcon={icon}
          />
        </div>
      </div>

      <footer className="app-footer">
        <p>Press space to start spinning the wheel</p>
      </footer>
      
      <WinnerPopup open={popup} winner={winner} onClose={() => setPopup(false)} />
    </div>
  );
}

export default App;
